import { DiscoverContextProvider } from "./context/discover_context";
import DiscoverComponent from "./components/discover_comp";

const DiscoverPage = () => {
    return (
        <DiscoverContextProvider>
            <DiscoverComponent />
        </DiscoverContextProvider>
    )
}

export default DiscoverPage;